import { Component, ReactElement } from 'react';
import { HelmetWithTitleAndDescription } from '../../../../../../shared/frontend/components/helmetHelper';
import { DisableAdsOnPage } from '../../../../../../shared/frontend/components/ads/disableAdsOnPage';
import styles from './policyPageStyles';

/* tslint:disable:max-line-length */

export default class CookiesPolicyPage extends Component<any, {}> {
  public render(): ReactElement<any> {
    return (
      <div>
        <HelmetWithTitleAndDescription title="Cookies Policy" />
        <DisableAdsOnPage />
        <div>
          <div className="slds-p-around--large text-white" style={{ backgroundColor: '#4f4b49' }}>
            <div className={styles.legals}>
              <h1 className="slds-text-heading--large slds-m-bottom--large">Cookies Policy</h1>
              <p>Last updated: July 1st, 2025</p>

              <p>
                This Cookies Policy explains how RaiderIO, Inc. ("RaiderIO", "we", "us", and "ours") use cookies and
                similar technologies to recognize you when you visit our websites at https://raider.io, ("Websites"). It
                explains what these technologies are and why we use them, as well as your rights to control our use of
                them.
              </p>

              <p>
                In some cases we may use cookies to collect personal information, or that becomes personal information
                if we combine it with other information. In such cases our Privacy Policy
                (https://raider.io/privacy-policy) will apply in addition to this Cookies Policy.
              </p>

              <h2>What are cookies?</h2>
              <p>
                Cookies are small data files that are placed on your computer or mobile device when you visit a website.
                Cookies are widely used by website owners in order to make their websites work, or to work more
                efficiently, as well as to provide reporting information.
              </p>
              <p>
                Cookies set by the website owner (in this case, RaiderIO) are called "first party cookies". Cookies set
                by parties other than the website owner are called "third party cookies". Third party cookies enable
                third party features or functionality to be provided on or through the website (e.g. like advertising,
                interactive content and analytics). The parties that set these third party cookies can recognize your
                computer both when it visits the website in question and also when it visits certain other websites.
              </p>

              <h2>Why do we use cookies?</h2>
              <p>
                We use first and third party cookies for several reasons. Some cookies are required for technical
                reasons in order for our Websites to operate, and we refer to these as "essential" or "strictly
                necessary" cookies. Other cookies also enable us to track and target the interests of our users to
                enhance the experience on our Online Properties. Third parties serve cookies through our Websites for
                advertising, analytics and other purposes. This is described in more detail below.
              </p>
              <p>
                The specific types of first and third party cookies served through our Websites and the purposes they
                perform are described below (please note that the specific cookies served may vary depending on the
                specific Online Properties you visit):
              </p>

              <h3>
                <u>Essential website cookies:</u>
              </h3>
              <p>
                These cookies are strictly necessary to provide you with services available through our Websites and to
                use some of its features, such as access to secure areas.
              </p>
              <p>
                <b>Who serves these cookies:</b>
              </p>
              <p>
                <table className={styles.inlineTable}>
                  <thead>
                    <tr>
                      <th>Cookie Provider</th>
                      <th>Website URL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>RaiderIO, Inc.</td>
                      <td>https://raider.io</td>
                    </tr>
                  </tbody>
                </table>
              </p>
              <p>
                <b>How to refuse:</b> Because these cookies are strictly necessary to deliver the Websites to you, you
                cannot refuse them. You can block or delete them by changing your browser settings however, as described
                below under the heading "How can I control cookies?".
              </p>

              <h3>
                <u>Analytics and customization cookies:</u>
              </h3>

              <p>
                These cookies collect information that is used either in aggregate form to help us understand how our
                Website are being used or how effective our marketing campaigns are, or to help us customize our
                Websites for you.
              </p>

              <p>
                <b>Who serves these cookies:</b>
              </p>
              <p>
                <table className={styles.inlineTable}>
                  <thead>
                    <tr>
                      <th>Cookie Provider</th>
                      <th>Website URL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Google</td>
                      <td>https://google.com</td>
                    </tr>
                    <tr>
                      <td>Quantcast</td>
                      <td>https://www.quantcast.com</td>
                    </tr>
                  </tbody>
                </table>
              </p>
              <p>
                <b>How to refuse:</b> To refuse these cookies, please follow the instructions below under the heading "
                How can I control cookies? ". Alternatively, please visit the relevant opt-out link below:
              </p>
              <p>
                <table className={styles.inlineTable}>
                  <thead>
                    <tr>
                      <th>Cookie Provider</th>
                      <th>Opt-out Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Google</td>
                      <td>https://google.com</td>
                    </tr>
                  </tbody>
                </table>
              </p>

              <h3>
                <u>Advertising cookies:</u>
              </h3>

              <p>
                These cookies are used to make advertising messages more relevant to you. They perform functions like
                preventing the same ad from continuously reappearing, ensuring that ads are properly displayed for
                advertisers, and in some cases selecting advertisements that are based on your interests.
              </p>

              <p>Who serves these cookies:</p>
              <p>
                <table className={styles.inlineTable}>
                  <thead>
                    <tr>
                      <th>Cookie Provider</th>
                      <th>Website URL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Playwire</td>
                      <td>https://playwire.com</td>
                    </tr>
                  </tbody>
                </table>
              </p>

              <p>
                <b>How to refuse:</b> To refuse these cookies, please follow the instructions below under the heading
                "How can I control cookies?". Alternatively, please visit the relevant opt-out link below:{' '}
              </p>

              <p>
                <table className={styles.inlineTable}>
                  <thead>
                    <tr>
                      <th>Cookie Provider</th>
                      <th>Opt-out Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Playwire</td>
                      <td>https://www.playwire.com/privacy-policy</td>
                    </tr>
                  </tbody>
                </table>
              </p>

              <h2>What about other tracking technologies, like web beacons?</h2>
              <p>
                Cookies are not the only way to recognize or track visitors to a website. We may use other, similar
                technologies from time to time, like web beacons (sometimes called "tracking pixels" or "clear gifs").
                These are tiny graphics files that contain a unique identifier that enable us to recognize when someone
                has visited our Websites. This allows us, for example, to monitor the traffic patterns of users from one
                page within our Websites to another, to deliver or communicate with cookies, to understand whether you
                have come to our Websites from an online advertisement displayed on a third-party website, to improve
                site performance, and to measure the success of e-mail marketing campaigns. In many instances, these
                technologies are reliant on cookies to function properly, and so declining cookies will impair their
                functioning.
              </p>

              <h2>Do you serve targeted advertising?</h2>
              <p>
                Third parties may serve cookies on your computer or mobile device to serve advertising through our
                Websites. These companies may use information about your visits to this and other websites in order to
                provide relevant advertisements about goods and services that you may be interested in. They may also
                employ technology that is used to measure the effectiveness of advertisements. This can be accomplished
                by them using cookies or web beacons to collect information about your visits to this and other sites in
                order to provide relevant advertisements about goods and services of potential interest to you. The
                information collected through this process does not enable us or them to identify your name, contact
                details or other details that directly identify you unless you choose to provide these.
              </p>

              <h2>How can I control cookies?</h2>
              <p>
                You have the right to decide whether to accept or reject cookies. You can exercise your cookie
                preferences by clicking on the appropriate opt-out links provided in the cookie table above.
              </p>
              <p>
                You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject
                cookies, you may still use our website though your access to some functionality and areas of our website
                may be restricted. As the means by which you can refuse cookies through your web browser controls vary
                from browser-to-browser, you should visit your browser's help menu for more information.
              </p>
              <p>
                In addition, most advertising networks offer you a way to opt out of targeted advertising. If you would
                like to find out more information, please visit http://www.aboutads.info/choices/ or
                http://www.youronlinechoices.com.
              </p>
              <h2>How often will you update this Cookies Policy?</h2>
              <p>
                We may update this Cookies Policy from time to time in order to reflect, for example, changes to the
                cookies we use or for other operational, legal or regulatory reasons. Please therefore re-visit this
                Cookies Policy regularly to stay informed about our use of cookies and related technologies.
              </p>
              <p>The date at the top of this Cookies Policy indicates when it was last updated.</p>
              <h2>Where can I get further information?</h2>
              <p>
                If you have any questions about our use of cookies or other technologies, please email us at
                privacy@raider.io or by post to:
              </p>
              <p>
                RaiderIO, Inc.
                <br />
                1887 Whitney Mesa Dr #4968
                <br />
                Henderson, NV 89014
                <br />
                United States
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
